export default [
  {
    path: '/card',
    component: () => import('@/views/LayoutPage/Cardcover')
  }
]
